export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8226.2a9f0549.jpg";